import { useMutation } from "@tanstack/react-query";
import apiInputService from "services/apiInputService";
import { FinishUploadPayload } from "./@types";

const finishAttachmentUpload = async (payload: FinishUploadPayload) => {
  const { data } = await apiInputService.post(
    "/ValidationSteps/proceed/finishUpload",
    payload,
  );

  return data;
};

export const useFinishAttachmentUpload = (options?: any) => {
  return useMutation(finishAttachmentUpload, {
    ...options,
  });
};
